jQuery( document ).ready(function() {

    var selected = $('#allPrixAcademie').val();

    $("#"+selected).removeClass('hidden');

    $('#allPrixAcademie').change(function(e){
        e.preventDefault();
        $('.description').addClass('hidden');
        var select = $(this).val();
        $("#"+select).removeClass('hidden');
    });
});